import {Controller} from "stimulus"
import $ from 'jquery';

export default class extends Controller {
    static targets = ["cardsGrid", "userMenuContainer", "userMenuBtn", "notifContainer", "notifTrigger","sidebar","bookingForm", "globalOverlay","topNavToggle"]
    static values = { index: Number, tipo: String }
    initialize() {
        let context = this;
        // Dibujar las cards en la vista
        const carsData = [
            {
                id: 1,
                name: "Toyota Corolla Sedan",
                provider: "Hertz",
                logo: "Hertz",
                price: 450.00,
                description: "Sedan mediano, ideal para viajes de negocio.",
                images: ["https://picsum.photos/seed/toyota1/400/250", "https://picsum.photos/seed/toyota2/400/250"],
                available: true
            },
            {
                id: 2,
                name: "Ford Mustang GT",
                provider: "Avis",
                logo: "Avis",
                price: 1200.00,
                description: "Experimenta la potencia en un convertible clásico.",
                images: ["https://picsum.photos/seed/ford1/400/250", "https://picsum.photos/seed/ford2/400/250"],
                available: true
            },
            {
                id: 3,
                name: "SUV BMW X5",
                provider: "Europcar",
                logo: "Europcar",
                price: 950.00,
                description: "Lujo y comodidad para la familia. Tracción 4x4.",
                images: ["https://picsum.photos/seed/bmw1/400/250", "https://picsum.photos/seed/bmw2/400/250"],
                available: true
            },
            {
                id: 4,
                name: "Economy Fiat 500",
                provider: "Budget",
                logo: "Budget",
                price: 280.00,
                description: "Pequeño, ágil y económico.",
                images: ["https://picsum.photos/seed/fiat1/400/250", "https://picsum.photos/seed/fiat2/400/250"],
                available: true
            }
        ];

        if (this.hasCardsGridTarget) {
            carsData.forEach(car => {
                this.cardsGridTarget.insertAdjacentHTML('beforeend', `
            <div class="b2b-card-container" id="card-${car.id}">
                <div class="b2b-card-inner">
                    <div class="b2b-card-face b2b-card-front">
                        <div class="b2b-card-header">
                            <div class="b2b-provider-logo">${car.logo}</div>
                            <div class="b2b-carousel" id="carousel-${car.id}">${car.images.map((img, i) => `<img src="${img}" class="${i === 0 ? 'active' : ''}">`).join('')}</div>
                        </div>
                        <div class="b2b-card-body">
                            <h3 class="b2b-product-name">${car.name}</h3>
                            <p class="b2b-provider-name">${car.provider}</p>
                            <div class="b2b-interactive-row" onclick="flipCard(${car.id}, 'price')">
                                <span class="b2b-price-trigger">$${car.price.toFixed(2)} <i class="ph ph-arrows-left-right"></i></span>
                            </div>
                            <div class="b2b-desc-trigger" onclick="flipCard(${car.id}, 'desc')">${car.description}</div>
                            <div class="b2b-card-footer">
                                <button class="b2b-btn-check" onclick="checkAvailability(${car.id}, this)"><span>Chequear Disponibilidad</span><i class="ph ph-magnifying-glass"></i></button>
                            </div>
                        </div>
                    </div>
                    <div class="b2b-card-face b2b-card-back"><div id="back-content-${car.id}" class="b2b-back-content"></div><button class="b2b-btn-back" onclick="unflipCard(${car.id})"><i class="ph ph-arrow-left"></i> Volver</button></div>
                </div>
            </div>`)
            })
        }

        if (this.hasUserMenuContainerTarget){
            $(this.userMenuBtnTarget).on('click', (e)=>{
                console.log('click')
                context.toggleUserMenu(e)
            })
            // this.userMenuBtnTarget.addEventListener('click', this.toggleUserMenu);
        }
        if (this.hasNotifContainerTarget) {
            this.notifTriggerTarget.addEventListener('click', this.toggleNotifications);
        }

        document.addEventListener('click', (e) => {
            if (!this.userMenuContainerTarget.contains(e.target)) this.closeUserMenu();
            if (!this.notifContainerTarget.contains(e.target)) this.closeNotifications();
        });

    }

    connect() {

    }

    toggleUserMenu(e) {
        console.log('toggle menu container')
        console.log(this.userMenuContainerTarget)
        console.log(this.hasUserMenuContainerTarget)
        if (this.hasUserMenuContainerTarget) {
            if (window.innerWidth <= 1024) {
                // e.stopPropagation();
                this.closeNotifications();
                this.userMenuContainerTarget.classList.toggle('b2b-active');
                this.handleOverlay(this.userMenuContainerTarget.classList.contains('b2b-active'));
            }
        }
    }

    closeUserMenu() {
        if (this.hasUserMenuContainerTarget) {
            this.userMenuContainerTarget.classList.remove('b2b-active');
            this.checkOverlay();
        }
    }

    toggleNotifications(e) {
        if (this.hasNotifContainerTarget) {
            if (window.innerWidth <= 1024) {
                e.stopPropagation();
                this.closeUserMenu();
                this.notifContainerTarget.classList.toggle('b2b-active');
                this.handleOverlay(this.notifContainerTarget.classList.contains('b2b-active'));
            }
        }
    }

    closeNotifications() {
        if (this.hasNotifContainerTarget) {
            this.notifContainerTarget.classList.remove('b2b-active');
            this.checkOverlay();
        }
    }

    handleOverlay(shouldShow) {
        if (shouldShow) {
            this.sidebarTarget.classList.remove('mobile-open');
            if (this.hasBookingFormTarget) {
                this.bookingFormTarget.classList.remove('mobile-open');
            }
            this.globalOverlayTarget.classList.add('active');
        } else {
            this.checkOverlay();
        }
    }

    checkOverlay() {
        let anyActive = this.sidebarTarget.classList.contains('mobile-open');

        if (this.hasUserMenuContainerTarget) {
            anyActive = this.userMenuContainerTarget.classList.contains('b2b-active')
        }
        if (this.hasNotifContainerTarget) {
            anyActive = this.notifContainerTarget.classList.contains('b2b-active')
        }
        if (this.hasBookingFormTarget) {
            anyActive = this.bookingFormTarget.classList.contains('b2b-active')
        }

        if (!anyActive) this.globalOverlayTarget.classList.remove('active');
    }
}